import React from 'react';

const SyncIcon = (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
        <path
            d="M1.5 7a5.5 5.5 0 019.4-3.9L12.5 4.5M12.5 7a5.5 5.5 0 01-9.4 3.9L1.5 9.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.5 1.5v3h-3M3.5 12.5v-3h3"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const CloseIcon = (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
        <path
            d="M3 3l6 6M9 3l-6 6"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
        />
    </svg>
);

const ContextSyncAlert = ({
    count,
    onReplaceAll,
    onViewMatches,
    onIgnore,
    isVisible,
}) => {
    if (!isVisible) return null;

    return (
        <div
            role="status"
            aria-live="polite"
            className="rs-app"
            style={{
                position: 'fixed',
                bottom: 24,
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 2000,
                display: 'flex',
                alignItems: 'center',
                gap: 14,
                padding: '10px 12px 10px 14px',
                background: 'var(--bg-card, #ffffff)',
                border: '1px solid var(--line, #e7e3da)',
                borderRadius: 10,
                boxShadow: '0 8px 24px rgba(14,14,16,0.08), 0 2px 6px rgba(14,14,16,0.04)',
                fontFamily: "Inter, system-ui, -apple-system, sans-serif",
                color: 'var(--ink, #0e0e10)',
                minWidth: 420,
                maxWidth: '92vw',
                minHeight: 'auto',
                animation: 'rsAlertIn 160ms ease-out',
            }}
        >
            <style>{`
                @keyframes rsAlertIn {
                    from { opacity: 0; transform: translateX(-50%) translateY(8px); }
                    to   { opacity: 1; transform: translateX(-50%) translateY(0); }
                }
            `}</style>

            <span
                style={{
                    display: 'inline-grid',
                    placeItems: 'center',
                    width: 30,
                    height: 30,
                    borderRadius: 8,
                    background: 'var(--accent-soft, #fbe8de)',
                    color: 'var(--accent, #d97757)',
                    flexShrink: 0,
                }}
            >
                {SyncIcon}
            </span>

            <div style={{ flexGrow: 1, minWidth: 0 }}>
                <div
                    style={{
                        fontSize: 10.5,
                        fontWeight: 600,
                        letterSpacing: '0.06em',
                        textTransform: 'uppercase',
                        color: 'var(--ink-3, #6c6a68)',
                        marginBottom: 2,
                    }}
                >
                    Smart replace
                </div>
                <div style={{ fontSize: 13, color: 'var(--ink, #0e0e10)', fontWeight: 500 }}>
                    This text appears in {count} other segment{count !== 1 ? 's' : ''}.
                </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0 }}>
                <button
                    type="button"
                    onClick={onViewMatches}
                    style={{
                        appearance: 'none',
                        height: 28,
                        padding: '0 10px',
                        background: 'transparent',
                        border: '1px solid var(--line, #e7e3da)',
                        borderRadius: 7,
                        font: 'inherit',
                        fontSize: 12,
                        fontWeight: 500,
                        color: 'var(--ink-2, #3a3835)',
                        cursor: 'pointer',
                    }}
                >
                    Review
                </button>
                <button
                    type="button"
                    onClick={onReplaceAll}
                    style={{
                        appearance: 'none',
                        height: 28,
                        padding: '0 12px',
                        background: 'var(--ink, #0e0e10)',
                        border: 0,
                        borderRadius: 7,
                        font: 'inherit',
                        fontSize: 12,
                        fontWeight: 600,
                        color: 'var(--bg, #fbfaf7)',
                        cursor: 'pointer',
                    }}
                >
                    Replace all
                </button>
                <button
                    type="button"
                    onClick={onIgnore}
                    aria-label="Dismiss"
                    style={{
                        appearance: 'none',
                        display: 'inline-grid',
                        placeItems: 'center',
                        width: 26,
                        height: 26,
                        background: 'transparent',
                        border: 0,
                        borderRadius: 6,
                        color: 'var(--ink-3, #6c6a68)',
                        cursor: 'pointer',
                        marginLeft: 2,
                    }}
                >
                    {CloseIcon}
                </button>
            </div>
        </div>
    );
};

export default ContextSyncAlert;
